export default __webpack_public_path__ + "static/media/chair.948aead3.png";